class EventDelegator {
  constructor(rootElement = document) {
    this.rootElement = rootElement; // 限定事件绑定范围
    this.eventHandlers = []; // 存储事件信息
  }

  /**
   * 注册事件委托
   * @param {string} eventType - 事件类型 (如 'click')
   * @param {string} selector - 目标元素的 CSS 选择器
   * @param {Function} callback - 事件回调函数
   */
  on(eventType, selector, callback) {
    const handler = (event) => {
      const matchingElements = Array.from(this.rootElement.querySelectorAll(selector));
      const targetElement = event.target;

      if (matchingElements.some((el) => el === targetElement)) {
        callback.call(targetElement, event, targetElement); // 将回调的 this 绑定到实际目标元素
      }
    };

    this.rootElement.addEventListener(eventType, handler);

    // 存储事件信息
    this.eventHandlers.push({ eventType, selector, handler });
  }

  /**
   * 移除所有事件委托
   */
  off() {
    this.eventHandlers.forEach(({ eventType, handler }) => {
      this.rootElement.removeEventListener(eventType, handler);
    });

    // 清空事件存储
    this.eventHandlers = [];
  }
}

class Apex {

  /** 查询商品数据 */
  static queryProduct(productHandle) {
    return fetch(`${Shopify.routes.root}products/${productHandle}.js`)
     .then((response) => {
        if (!response.ok) {
          throw new Error(`查询商品失败，状态码: ${response.status}`);
        }
        return response.json();
      })
     .then((data) => {
        console.log("商品数据:", data);
        return data; // 返回查询到的商品数据
      })
    .catch((error) => {
        console.error("查询商品失败:", error);
        throw error;
      });
  }

  /**
   * 将商品添加到购物车
   * @param {string} productId - 商品的变体 ID
   * @param {number} quantity - 添加的数量，默认为 1
   * @returns {Promise} - 返回一个 Promise，表示请求的状态
   */
  static addProduct(productId, quantity = 1) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`添加商品失败，状态码: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("商品已添加到购物车:", data);
        return data; // 返回添加到购物车的商品数据
      })
      .catch((error) => {
        console.error("添加商品到购物车失败:", error);
        throw error;
      });
  }

  static currencyFormatter() {
    const intlNum = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });
    const formatPrice = (price) => {
      if (!price) {
        return "";
      }
      return `${intlNum.format(price / 100)} ${Shopify.currency.active}`;
    };
    return {
      intlNum,
      formatPrice,
    };
  }

  static generateSrcset(imageObjectOrString, widths = []) {
    let imageUrl, maxWidth;
    if (typeof imageObjectOrString === "string") {
      imageUrl = new URL(imageObjectOrString.startsWith("//") ? `https:${imageObjectOrString}` : imageObjectOrString);
      maxWidth = parseInt(imageUrl.searchParams.get("width"));
    } else {
      imageUrl = new URL(imageObjectOrString["src"].startsWith("//") ? `https:${imageObjectOrString["src"]}` : imageObjectOrString["src"]);
      maxWidth = imageObjectOrString["width"];
    }
    return widths
      .filter((width) => width <= maxWidth)
      .map((width) => {
        imageUrl.searchParams.set("width", width.toString());
        return `${imageUrl.href} ${width}w`;
      })
      .join(", ");
  }

  static createMediaImg(media, widths = [], properties = {}) {
    const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]),
      src = media["preview_image"]["src"],
      featuredMediaUrl = new URL(src.startsWith("//") ? `https:${src}` : src);
    for (const propertyKey in properties) {
      image.setAttribute(propertyKey, properties[propertyKey]);
    }
    image.alt = media["alt"];
    image.src = featuredMediaUrl.href;
    image.srcset = this.generateSrcset(media["preview_image"], widths);
    return image;
  }
}

window.Apex = Apex;
window.EventDelegator = EventDelegator;
